export default __webpack_public_path__ + "static/media/self_view.13def51c.svg";